export default __webpack_public_path__ + "static/media/7.75106f05.jpg";